import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ProfileMenuComponent } from '@sbe-spinoff-client/app-shell';
import { StaffAuthService } from '../../core/staff-auth.service';

/**
 * 헤더 우측 계정 드롭다운 — 실제 렌더링은 `@sbe-spinoff-client/app-shell`의
 * `ProfileMenuComponent`(인증 서비스에 의존하지 않는 순수 프레젠테이션 컴포넌트)에 위임한다.
 * 이 컴포넌트는 `StaffAuthService`(phone+password 쿠키 세션)에서 `staff`만 뽑아 넘기는 얇은
 * 어댑터다 — `@sbe-spinoff-client/spinoff-platform`의 `SpinoffProfileMenuComponent`와 같은
 * 패턴(2026-08-12, 로그인 가능한 모든 앱이 같은 드롭다운을 쓰도록 통일). `StaffMe`는
 * `name`/`email`/`phone`을 그대로 갖고 있어 `ProfileMenuUser`에 구조적으로 호환된다.
 */
@Component({
  selector: 'app-staff-profile-menu',
  imports: [ProfileMenuComponent],
  template: `<sbe-profile-menu [user]="auth.staff()" (logoutRequested)="logoutRequested.emit()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffProfileMenuComponent {
  protected readonly auth = inject(StaffAuthService);

  readonly logoutRequested = output<void>();
}
